// extracted by mini-css-extract-plugin
module.exports = {"page":"dividends_page__ILYFm","container":"dividends_container__98JXM","empty":"dividends_empty__1-IBX","text":"dividends_text__1aSom"};